module.exports = __webpack_public_path__ + "static/img/05yongzidaibei.604aa858.gif";